<template>
  <v-select
    ref="controlFocoSelectSubrubro"
    label="Subrubro*"
    v-model="iModel"
    :items="items"
    item-value="Id_Subrubro"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectSubrubro",
  props: {
    id_Rubro: Number,
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_Subrubro == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectSubrubro", this.setearFoco);
    eventBus.$on("listarItemsSelectSubrubro", this.listarItems);
    this.listarItems(this.id_Rubro);
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectSubrubro", this.setearFoco);
    eventBus.$off("listarItemsSelectSubrubro", this.listarItems);
  },
  methods: {
    listarItems(id_Rubro) {
      if (id_Rubro) {
        this.loading = true;
        HttpHelper.get("Subrubro/ListarPorRubro", {
          id_Rubro: id_Rubro
        })
          .then(response => {
            this.items = response.data;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    setearFoco() {
      this.$refs.controlFocoSelectSubrubro.focus();
    }
  }
};
</script>
